module.exports = __webpack_public_path__ + "static/media/turkce.58452d87.svg";